import React from 'react';
import { Box } from '@mui/material';
import { BottomNav } from './BottomNavigation';

interface AppLayoutProps {
  children: React.ReactNode;
  title?: string;
}

export const AppLayout: React.FC<AppLayoutProps> = ({ children }) => {
  return (
    <Box 
      sx={{ 
        display: 'flex', 
        flexDirection: 'column', 
        minHeight: '100vh', 
        backgroundColor: '#F4F5F7',
        width: '100%',
      }}
    >
      <Box
        sx={{
          flex: 1,
          width: '100%',
          maxWidth: {
            xs: '100%',
            sm: '100%',
            md: '720px',
            lg: '1024px',
          },
          margin: '0 auto',
          paddingTop: { xs: '12px', sm: '16px', md: '24px', lg: '32px' },
          paddingX: { xs: '12px', sm: '16px', md: '24px', lg: '32px' },
          paddingBottom: '80px',
          boxSizing: 'border-box',
        }}
      >
        {children}
      </Box>

      <BottomNav />
    </Box>
  );
};